import periodRangeToDates from '../liveReportHelpers/periodRangeToDates'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// AI-CONTEXT: See docs/pitfalls.md#api-callable-timestamp-vs-ms
//
// Epoch-ms bounds for a period range, for data paths that take numbers
// (useHierarchyData / callFetchHierarchyData). Builds on periodRangeToDates
// for the local-day bounds (start 00:00, end 23:59:59.999); an open bound
// falls back to all time, so a null range is "all data".

export const ALL_TIME_START = 0
export const ALL_TIME_END = 8640000000000000

/**
 * @param {{start: string|null, end: string|null}|null|undefined} range
 * @returns {{startMs: number, endMs: number}}
 */
const periodRangeToMs = (range) => {
    const { startDate, endDate } = periodRangeToDates(range)
    return {
        startMs: startDate ? startDate.getTime() : ALL_TIME_START,
        endMs: endDate ? endDate.getTime() : ALL_TIME_END,
    }
}

export default periodRangeToMs
